import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CheckCircleOutlineGrayIcon, RemoveCircleOutlineRedIcon, } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
import { VIEW_REQUEST_PROPOSAL_UNREGISTERED } from '@/utils/constants/viewRequest/proposal';
/**
 * コンサルタントの案件意向登録ステータス表示用のコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalProposalStatusIconTextGroup = (props) => {
    const { className = '', isProposalUnregistered } = props;
    return (_jsx(IconTextGroup, Object.assign({ className: className }, { children: isProposalUnregistered ? (_jsxs(_Fragment, { children: [_jsx(RemoveCircleOutlineRedIcon, { size: 'sm' }), _jsx(Text, Object.assign({ color: 'error', size: 'sm' }, { children: VIEW_REQUEST_PROPOSAL_UNREGISTERED.label }))] })) : (_jsxs(_Fragment, { children: [_jsx(CheckCircleOutlineGrayIcon, { size: 'sm' }), _jsx(Text, Object.assign({ color: 'textGray', size: 'sm' }, { children: "\u767B\u9332\u6E08" }))] })) })));
};
